import React, { Component } from "react";
import _ from "lodash";
import moment from "moment";

import IntelliportMessagesTable from "../components/IntelliportMessagesTable";

import IntelliportMessagesModel from "../components/IntelliportMessagesModel";

import {
    Layout,
    Button,
    Row,
    Col,
    Icon,
    DatePicker,
    message,
    Input,
    Switch,
} from "antd";

class IntelliportMessagesScreen extends Component {
    state = {
        autoReload:
            localStorage.getItem("table_autoReload") !== undefined &&
            localStorage.getItem("table_autoReload") == "true"
                ? true
                : false,
        dataLoading: true,
        dataAll: [],
        searchedTextValue: "",
        data: [],
        dateFrom: moment().subtract(30, "minutes"),
        dateTo: moment().endOf("day"),
    };

    componentWillMount() {
        this.loadData(this.state.dateFrom, this.state.dateTo);

        // Checking auto reload data
        this.intervalId = setInterval(() => {
            if (this.state.autoReload) {
                this.loadData(this.state.dateFrom, this.state.dateTo);
            }
        }, 30000);
    }

    loadData(dateFrom = null, dateTo = null) {
        dateFrom = dateFrom ? dateFrom.format() : null;
        dateTo = dateTo ? dateTo.format() : null;
        this.setState({
            dataLoading: true,
        });
        IntelliportMessagesModel.getAll(dateFrom, dateTo)
            .then((data) => {
                this.setState({
                    dataLoading: false,
                    dataAll: data,
                    data: data,
                });
            })
            .catch(() => {
                message.warning(
                    "Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby."
                );
                this.setState({
                    dataLoading: false,
                });
            })
            .then(() => {
                if (this.state.searchedTextValue) {
                    this.onSearchSerialNumber(this.state.searchedTextValue);
                }
            })
    }

    onSearchSerialNumber(serialNumber) {
        const dataAll = this.state.dataAll;
        this.setState({
            data: _.filter(dataAll, (d) => {
                if (typeof d["sensor_serial_number"] != "undefined") {
                    return d["sensor_serial_number"]
                        .toLowerCase()
                        .includes(serialNumber.toLowerCase());
                } else {
                    return dataAll;
                }
            }),
        });
    }

    onDateRangeChanged(dates, dateStrings) {
        this.setState({
            dateFrom: dates[0],
            dateTo: dates[1],
        });
        this.loadData(dates[0], dates[1]);
    }

    render() {
        return (
            <Layout.Content
                style={{ margin: "24px 16px 0", minHeight: "auto" }}
            >
                <div style={{ padding: 24, background: "#fff" }}>
                    <h2>Intelliport - Zprávy</h2>
                    <div style={{ marginBottom: "20px" }}>
                        <Row>
                            <Col span={8}>
                                <DatePicker.RangePicker
                                    defaultValue={[
                                        this.state.dateFrom,
                                        this.state.dateTo,
                                    ]}
                                    ranges={{
                                        Dnes: [
                                            moment().startOf("day"),
                                            moment().endOf("day"),
                                        ],
                                        Včera: [
                                            moment()
                                                .add(-1, "days")
                                                .startOf("day"),
                                            moment()
                                                .add(-1, "days")
                                                .endOf("day"),
                                        ],
                                        "Poslední týden": [
                                            moment()
                                                .add(-7, "days")
                                                .startOf("day"),
                                            moment().endOf("day"),
                                        ],
                                    }}
                                    allowClear={false}
                                    placeholder={["Od", "Do"]}
                                    format="DD.MM.YYYY HH:mm"
                                    showTime={{ format: "HH:mm" }}
                                    onOk={this.onDateRangeChanged.bind(this)}
                                    style={{ width: 300 }}
                                />
                                <Input.Search
                                    placeholder="Najít podle sériového čísla"
                                    value={this.state.searchedTextValue}
                                    onSearch={this.onSearchSerialNumber.bind(
                                        this
                                    )}
                                    onChange={(e) => {
                                        this.setState({
                                            searchedTextValue: e.target.value,
                                        });
                                    }}
                                    style={{ width: 300 }}
                                />
                            </Col>

                            <Col
                                span={8}
                                offset={8}
                                style={{ textAlign: "right" }}
                            >
                                <Switch
                                    checked={this.state.autoReload}
                                    onChange={(checked) => {
                                        localStorage.setItem(
                                            "table_autoReload",
                                            checked
                                        );
                                        this.setState({
                                            autoReload: checked,
                                        });
                                    }}
                                />{" "}
                                Automatická obnova
                                <Button
                                    type="default"
                                    onClick={() => {
                                        this.loadData(
                                            this.state.dateFrom,
                                            this.state.dateTo
                                        );
                                    }}
                                    style={{ marginLeft: 10 }}
                                >
                                    <Icon type="sync" />
                                </Button>
                            </Col>
                        </Row>
                    </div>
                    <IntelliportMessagesTable
                        data={this.state.data}
                        loading={this.state.dataLoading}
                        onDetailRow={(record) => {}}
                        onRemoveRow={(id) => {
                            IntelliportMessagesModel.remove(id).then(() => {
                                this.loadData(
                                    this.state.dateFrom,
                                    this.state.dateTo
                                );
                            });
                        }}
                    />
                </div>
            </Layout.Content>
        );
    }
}

export default IntelliportMessagesScreen;



// WEBPACK FOOTER //
// ./src/screens/IntelliportMessagesScreen.js